import { render, staticRenderFns } from "./questionParse.vue?vue&type=template&id=6e5a2cec&scoped=true"
import script from "./questionParse.vue?vue&type=script&lang=js"
export * from "./questionParse.vue?vue&type=script&lang=js"
import style0 from "./questionParse.vue?vue&type=style&index=0&id=6e5a2cec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5a2cec",
  null
  
)

export default component.exports